export const modalReservationDirect = {
  header: {
    title: "Reservas directas vía web",
    subtitle: "Configura qué ve el huésped y cómo se aplican reglas.",
  },
  tabs: {
    reservations: "Estado reserva",
    ratePlans: "Tarifas",
    promotions: "Promociones",
    addons: "Cargos adicionales",
    payments: "Precios y Pagos",
    share: "Compartir",
  },
  common: {
    close: "Cerrar",
    updating: "Actualizando…",
    hotel: "Hotel",
    apartment: "Apartamento",
    visible: "Visible",
    default: "Por defecto",
    dragToReorder: "Arrastrar para reordenar",
    saving: "Guardando…",
    preview: "Vista previa",
  },
  toast: {
    successTitle: "Éxito",
  },
  save: {
    ratePlans: "Guardar tarifas",
    promotions: "Guardar promociones",
    addons: "Guardar cargos",
    default: "Guardar",
  },
  reservations: {
    cardTitle: "Estado de reservas directas",
    cardDesc: "Activa/desactiva la disponibilidad de reservas directas (global y por unidad).",
    activateTitle: "Activar reservas directas",
    activateHelp: "Si está desactivado, no podrás activar unidades individualmente.",
    colName: "Alojamiento / Unidad",
    colCapacity: "Capacidad",
    colAvailable: "Disponible",
    emptyUnits: "No hay unidades configuradas para esta propiedad.",
  },
  ratePlans: {
    title: "Tarifas visibles en Reserva Directa",
    hotelDesc: "Configura qué tarifas se muestran para cada tipo de habitación",
    apartmentDesc: "Define qué Rate Plans verá el huésped, cuál es la por defecto y el orden",
    loading: "Cargando tarifas…",
    emptyApartment: "No hay tarifas configuradas para esta propiedad.",
    emptyHotel: "No hay tipos de habitación configurados para este hotel.",
    emptyRoom: "No hay tarifas configuradas para esta habitación.",
    colTarifa: "Tarifa",
    colVisibleName: "Nombre visible",
    visibleNameTooltip: "Nombre opcional para mostrar al huésped",
    namePlaceholderApartment: "Ej: No reembolsable / Flexible",
    namePlaceholderHotel: "Ej: Desayuno incluido",
    derivedBadge: "Derivada",
    rulesApartment: "Reglas: mínimo 1 visible y 1 por defecto (que esté visible).",
    rulesHotel: "Cada habitación debe tener al menos 1 tarifa visible y 1 por defecto.",
  },
  rooms: {
    ratesCount: "{count} tarifa | {count} tarifas",
    meta: "Capacidad: {capacity} • Adultos: {adults} • Niños: {children}",
  },
  promotions: {
    title: "Promociones en Reserva Directa",
    desc: "Controla cuáles se muestran, si se aplican automáticamente y el orden.",
    loading: "Cargando promociones…",
    empty: "No hay promociones configuradas para esta propiedad.",
    colPromo: "Promoción",
    colBadge: "Badge",
    badgeTooltip: "Texto corto (ej: -10%, Oferta, Early Bird).",
    colAuto: "Auto-aplicar",
    colStackable: "Acumulable",
    badgePlaceholder: "Ej: -10% / Oferta",
    tip: "Tip: si no quieres que una promo afecte el precio final, desactiva “Auto-aplicar” y déjala visible.",
    fromDate: "Desde {date}",
    untilDate: "Hasta {date}",
  },
  addons: {
    loading: "Cargando configuración…",
    subtabOccupancy: "Descuento por ocupación",
    subtabExtraGuest: "Cargo por huésped adicional",
    baseOccupancyTitle: "Ocupación base",
    baseOccupancyDesc: "El precio habitual corresponde a esta ocupación. Para menos huéspedes aplicas una reducción.",
    guestsLabel: "huéspedes",
    headOccupancy: "Ocupación",
    headRule: "Regla",
    headValue: "Valor",
    headActive: "Activo",
    guestWord: "huésped | huéspedes",
    usualPrice: "Precio habitual",
    modePercent: "Reducción %",
    modeFixed: "Reducción fija (por noche)",
    occupancyExample: "Ejemplo: base 4 huéspedes y descuentos para 3, 2 y 1.",
    configTitle: "Configuración",
    configDesc: "Aplica un recargo por cada huésped extra por encima de la ocupación incluida.",
    activate: "Activar",
    includedTitle: "Ocupación incluida",
    includedDesc: "Se toma automáticamente según la capacidad del alojamiento.",
    maxExtraLabel: "Máximo de huéspedes extra permitidos",
    maxHelpHtml: "Cuántos huéspedes se pueden añadir <b>además de la ocupación incluida</b>.<br />Si pones <b>0</b>, no se permiten huéspedes extra.<br />Si lo dejas vacío, no hay límite.",
    chargeTypeLabel: "Tipo de cargo",
    chargeTypeFixed: "Importe fijo",
    chargeTypePercentage: "Porcentaje",
    chargeTypeHelp: "Fijo: {currency} por huésped extra. Porcentaje: % sobre precio base.",
    priceLabel: "Precio por cada huésped adicional",
    appliesHelp: "Se aplica por cada huésped adicional.",
    appliesBlockedNote: "(No se permiten huéspedes extra cuando el máximo está en 0)",
    applicationLabel: "Aplicación",
    applicationNote: "Por ahora este cargo se aplica por noche.",
    previewFixed: "Cada huésped adicional suma <b>{amount}</b> por noche.",
    previewPercent: "Cada huésped adicional suma <b>{percent}%</b> sobre el precio base por noche.",
    singleValueNote: "Esto es un <b>único valor</b> (ej: +10 {currency} o +15% por huésped extra).",
  },
  payments: {
    title: "Precios y Pagos",
    desc: "Tipo de cobro y descuentos para reservas directas.",
    paymentTypeTitle: "Tipo de pago",
    onArrivalLabel: "Pago a la llegada",
    onArrivalDesc: "El huésped reserva y paga directamente al llegar.",
    onlineLabel: "Pago online",
    onlineDesc: "El huésped paga online al completar la reserva.",
    discountsTitle: "Descuentos",
    enableDiscount: "Activar descuento en reservas directas",
    discountTypeTitle: "Tipo de descuento",
    typePercentage: "Porcentaje",
    typePercentageDesc: "Descuento proporcional al total.",
    typeFixed: "Fijo",
    typeFixedDesc: "Cantidad fija a descontar.",
    valueTitle: "Valor",
    placeholderPercentage: "Ej: 10",
    placeholderFixed: "Ej: 15.00",
    helpPercentage: "Máximo 100%. Se aplica sobre el total.",
    helpFixed: "Se descuenta una cantidad fija en {currency}.",
    previewPercentage: "Se aplicará un {percent}% de descuento.",
    previewFixed: "Se aplicará un descuento de {amount}.",
  },
  share: {
    title: "Compartir",
    desc: "Copia el enlace de reserva directa y compártelo por WhatsApp o abre la vista como visitante.",
    linkLabel: "Link de reservas",
    linkHelp: "Este enlace es el que compartes con huéspedes.",
    viewAsGuest: "Ver como visitante",
    tip: "Tip: comparte este link en tu bio, mensajes automáticos y campañas.",
    whatsappMessage: "Hola 👋 Te comparto el enlace para reservar: {link}",
  },
  errors: {
    loadRatePlans: "No se pudieron cargar las tarifas.",
    saveRatePlans: "No se pudieron guardar las tarifas.",
    roomMinVisible: 'La habitación "{name}" debe tener al menos 1 tarifa visible.',
    roomExactlyOneDefault: 'La habitación "{name}" debe tener exactamente 1 tarifa por defecto.',
    roomDefaultMustBeVisible: 'En "{name}", la tarifa por defecto debe estar visible.',
    aptMinVisible: "Debes dejar al menos 1 tarifa visible.",
    aptExactlyOneDefault: "Debe existir exactamente 1 tarifa por defecto.",
    aptDefaultMustBeVisible: "La tarifa por defecto debe estar visible.",
    loadPromotions: "No se pudieron cargar las promociones.",
    savePromotions: "No se pudieron guardar las promociones.",
    saveAddons: "No se pudieron guardar los cargos adicionales.",
    maxExtraRange: "El máximo de huéspedes extra debe estar entre 0 y 50 (o vacío = sin límite).",
    extraPriceInvalid: "El precio por huésped adicional debe ser válido (>= 0).",
    percentRange: "El porcentaje debe estar entre 0 y 100.",
    baseOccupancyRange: "La ocupación base debe estar entre 1 y {max}.",
    discountValuesInvalid: "Los valores de descuento deben ser números válidos (>= 0).",
    discountPercentMax: "Los descuentos en % no pueden superar 100.",
    updateFailed: "No se pudo actualizar.",
    updateUnitFailed: "No se pudo actualizar el estado de la unidad.",
    updateGlobalFailed: "No se pudo actualizar el estado global.",
    noLinkCopy: "No hay link para copiar.",
    copyFailed: "No se pudo copiar el link.",
    noLinkShare: "No hay link para compartir.",
    noLinkOpen: "No hay link para abrir.",
    updatePaymentType: "No se pudo actualizar el tipo de pago.",
    savePayments: "No se pudieron guardar los cambios.",
  },
  success: {
    ratePlansSaved: "Tarifas guardadas correctamente.",
    promotionsSaved: "Promociones guardadas correctamente.",
    addonsSaved: "Cargos adicionales guardados correctamente.",
    updated: "Actualizado correctamente.",
    globalUpdated: "Estado global actualizado.",
    linkCopied: "Link copiado.",
    changesSaved: "Cambios guardados.",
  },
};
